const Texts = {
  baseStyle: {
    color: "black",
    fontFamily: "body",
  },
  variants: {
    base: {
      color: "black",
      fontSize: ["0.875rem", "1rem", "1.125rem", "1.25rem", "1.375rem"],
    },
    subtext: {
      color: "white",
      fontWeight: "subtextWeight",
      opacity: 0.75,
    },
    subtextResponsive: {
      color: "white",
      fontWeight: "subtextWeight",
      opacity: 0.75,
      fontSize: ["0.625em", "0.75em", "0.875em", "1em", "1.125em"],
    },
    card: {
      color: "black",
      fontSize: "0.9em",
    },
    register: {
      color: "black",
      fontSize: "1.3em",
      fontStyle: "italic",
    },
    table: {
      color: "black",
      fontSize: ["0.7em", "0.7em", "0.8em", "0.8em", "0.9em"],
    },
  },
}

export default Texts
